import { Component, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '../../pipes/translate.pipe';
import {
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonItem,
  IonTextarea,
  IonButton,
  IonButtons,
  IonIcon
} from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { close } from 'ionicons/icons';
import { ModalService } from '../../services/modal.service';

@Component({
  selector: 'app-rejection-modal',
  templateUrl: './rejection-modal.component.html',
  styleUrls: ['./rejection-modal.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    TranslatePipe,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonItem,
    IonTextarea,
    IonButton,
    IonButtons,
    IonIcon
  ]
})
export class RejectionModalComponent {
  rejectionReason = '';

  @Output() confirm = new EventEmitter<string>();
  @Output() cancel = new EventEmitter<void>();

  constructor(private modalService: ModalService) {
    addIcons({ close });
  }

  onCancel(): void {
    this.modalService.dismiss();
  }

  onCloseModal(): void {
    this.modalService.dismiss();
  }

  onConfirm(): void {
    this.modalService.dismiss({ rejectionReason: this.rejectionReason });
  }
}